import Pagination from "@mui/material/Pagination";
import "./TablePaginationBar.css";

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

export default function TablePaginationBar({
  page = 1,
  rowsPerPage = 10,
  total = 0,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
  onPageChange,
  onRowsPerPageChange,
}) {
  const safeRows = rowsPerPage || 10;
  const pageCount = Math.max(1, Math.ceil((total || 0) / safeRows) || 1);
  const safePage = Math.min(Math.max(page || 1, 1), pageCount);
  const from = total === 0 ? 0 : (safePage - 1) * safeRows + 1;
  const to = Math.min(safePage * safeRows, total);

  return (
    <div className="table-pagination-bar">
      <span className="table-pagination-meta">
        {total === 0 ? "No records" : `${from}–${to} of ${total}`}
      </span>
      <div className="table-pagination-controls">
        <label className="table-pagination-rows">
          Rows
          <select
            value={safeRows}
            onChange={(e) => onRowsPerPageChange?.(Number(e.target.value))}
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>
        <Pagination
          count={pageCount}
          page={safePage}
          onChange={(_, value) => onPageChange?.(value)}
          shape="rounded"
          size="small"
          siblingCount={1}
          boundaryCount={1}
          disabled={total === 0}
        />
      </div>
    </div>
  );
}
